var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('practical-exam-form',{attrs:{"loading":_vm.loading,"exam":_vm.exam},on:{"on-submit":_vm.onSubmit,"on-close":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }